// extracted by mini-css-extract-plugin
export default {"container":"BaseAvatar_container_Ii3pT","circle":"BaseAvatar_circle_mpNrM","image":"BaseAvatar_image_met4K","online":"BaseAvatar_online_RyUZY","small":"BaseAvatar_small_LR3ge"};